import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contactpage',
  imports: [FormsModule],
  templateUrl: './contactpage.html',
  styleUrl: './contactpage.css'
})
export class Contactpage {
  @ViewChild('popup') myDiv!: ElementRef;
  constructor(private router: Router) { }
  navigateAndScroll(route: string, elementId: string) {
    this.router.navigate([route]).then(() => {
      const el = document.getElementById(elementId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }


  changeClass() {
    this.myDiv.nativeElement.classList.remove('popdown');
    this.myDiv.nativeElement.classList.add('popup');
    console.log(this.myDiv);
  }

  // Add a method to hide it:
  hidePopup() {
    this.myDiv.nativeElement.classList.remove('popup');
    this.myDiv.nativeElement.classList.add('popdown');
  }





}
